import { render } from "./CookiebarIntroductionArea.ce.vue?vue&type=template&id=172cc991"
import script from "./CookiebarIntroductionArea.ce.vue?vue&type=script&lang=js"
export * from "./CookiebarIntroductionArea.ce.vue?vue&type=script&lang=js"

import exportComponent from "/builds/govbr-ds/wbc/govbr-ds-wbc/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__